export default __webpack_public_path__ + "static/og-image-jobs-52f0da92af2e98434255a1416f4a6b2c.png";